/* Glide layer (from option D): Lenis inertia scrolling + magnetic buttons.
   Site-wide (not index-gated). CDN Lenis for now; self-host at next cycle. */
(() => {
  if (!document.documentElement.classList.contains('sm-js')) return;

  const s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/lenis@1/dist/lenis.min.js';
  s.onload = () => { if (window.Lenis) new Lenis({ autoRaf: true, lerp: 0.11 }); };
  document.head.appendChild(s);

  const MAG = 9;
  const attach = () => {
    document.querySelectorAll('.button, a[class*="button"], button[type="submit"]').forEach((b) => {
      if (b.dataset.smMag) return;
      b.dataset.smMag = '1';
      b.classList.add('sm-mag');
      b.addEventListener('mousemove', (e) => {
        const r = b.getBoundingClientRect();
        const dx = (e.clientX - r.left - r.width / 2) / r.width;
        const dy = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = `translate(${(dx * MAG).toFixed(1)}px, ${(dy * MAG).toFixed(1)}px)`;
      });
      b.addEventListener('mouseleave', () => { b.style.transform = ''; });
    });
  };
  if (document.readyState === 'complete') attach();
  else addEventListener('load', attach, { once: true });
})();
